import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Container, Card, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import LoadingIndicator from '../components/loading-indicator';
import { Footer } from '../components/common/Footer';
import { GenericPopup } from '../components/popups/GenericPopup';
import { SimpleSlider } from '../components/common/SimpleSlider';
import { Videos } from './home/Videos';
import icon_tt from '../../assets/img/ThinkingTalent.svg';
import icon_mp from '../../assets/img/MindPattern.svg';
import icon_quest from '../../assets/img/Questionnaire.svg';
import { BoostYourGrowth } from '../components/boost-your-growth/BoostYourGrowth';
import ThinkingTalentsHome from './home/thinkingTalents/thinkingTalentsHome';
import MindPatternsHome from './home/mindPatterns/mindPatternsHome';
import { NewMemberDiscovery } from './home/questionnaires/NewMemberDiscovery';
import TeamsHome from './home/teams/teamsHome';
import classnames from 'classnames';
import ReactPlayer from 'react-player';

export const HomePage = () => {
  const user = useSelector(state => state.user);
  const pdf = useSelector(state => state.pdf);
  const [currentPopupIndex, setCurrentPopupIndex] = useState(0);
  const nextPopup = () => {
      setCurrentPopupIndex(currentPopupIndex+1);
  }
  const resetPopupIndex = () => {
    setCurrentPopupIndex(0);
  }

  const popups = useMemo(() => {
    if (!user?.account?.popups) return [];

    resetPopupIndex();

    return user.account.popups.filter((popup) => {
      const { exposition_frequency, id } = popup;
      const key = `user_${user.id}_popup_${id}`;

      if (exposition_frequency === 0) { // "On each login"
        if (!sessionStorage.getItem(key)) {
          return true;
        }
        return false;
      }

      if (exposition_frequency === 1) { // "Just once and never again"
        if (!localStorage.getItem(key)) {
          return true;
        }
        return false;
      }

      if (exposition_frequency === 2) { // "On all user visits to the page"
        return true;
      }

      return false;
    });
  }, [user?.account?.popups, user?.id]);

  const sliders = useSelector(state => state?.user?.account?.home_slides)
  const videos = useSelector(state => state.videos);
  const systemCheck = useSelector(state => state?.systemCheck?.data?.data)
  const thinking_talents_on = systemCheck?.thinking_talents_on
  const mind_patterns_on = systemCheck?.mind_patterns_on
  const teams_on = systemCheck?.teams_on

  const [activeTab, setActiveTab] = useState('thinkingTalents');
  const toggle = tab => {
    if(activeTab !== tab) setActiveTab(tab);
  }

  return (
    <>
      <Container fluid className="flex-grow-1" style={{ minWidth: 0, maxWidth: '100%' }}>

        {sliders?.length > 0 &&
            <div className="mb-3 pt-md-4" id="homeSlider">
                <SimpleSlider dots={true} arrows={false} dotsClass="dots-on-home d-flex align-items-center justify-content-center pt-2" items={sliders} ></SimpleSlider>
            </div>
        }

        {false && <Card className="px-3 py-md-4 mb-3">
                <div className="px-md-3">
                    {videos?.data?.length > 0 &&
                        <div className="videos-list-home">
                            <div className="encabezado">
                                <div className="mb-0 pt-2 pb-1 d-flex align-items-end">
                                    <h6 className="mb-0 title-underline pr-5">Videos</h6>
                                </div>
                                <span className="border border-info d-none d-md-block"></span>
                            </div>
                            <Videos />
                        </div>
                    }
                </div>
            </Card>
        }

        {user.id && !user.isPending &&
            <section id="questionnaires">
                <BoostYourGrowth />
            </section>
        }

        {((!user.isPending && thinking_talents_on) || (mind_patterns_on) || (user.id && !user.isPending && user.account.questionnaires_count > 0)) &&
          <div className='border rounded mb-3'>
            <Nav tabs>
              {!user.isPending && thinking_talents_on && 
              <NavItem className='flex-fill text-center'>
                <NavLink className={classnames('d-flex justify-content-center', { active: activeTab === 'thinkingTalents' })} onClick={() => { toggle('thinkingTalents'); }}>
                  <i className='mr-2'><img src={icon_tt} width="24" height="24" alt='Thinking Talent' /></i>
                  <h3 className='h5 mb-0 py-1'>Thinking Talents</h3>
                </NavLink>
              </NavItem>
              }
              {mind_patterns_on &&
              <NavItem className='flex-fill text-center'>
                <NavLink className={classnames('d-flex justify-content-center', { active: activeTab === 'mindPattern' })} onClick={() => { toggle('mindPattern'); }}>
                  <i className='mr-2'><img src={icon_mp} width="24" height="24" alt='Mind Pattern' /></i>
                  <h3 className='h5 mb-0 py-1'>Mind Pattern</h3>
                </NavLink>
              </NavItem>
              }
              {user.id && !user.isPending && user.account.questionnaires_count > 0 &&
              <NavItem className='flex-fill text-center'>
                <NavLink className={classnames('d-flex justify-content-center', { active: activeTab === 'questionnaire' })} onClick={() => { toggle('questionnaire'); }}>
                  <i className='mr-2'><img src={icon_quest} width="24" height="24" alt='Mind Pattern' /></i>
                  <h3 className='h5 mb-0 py-1'>Questionnaire</h3>
                </NavLink>
              </NavItem>
              }
            </Nav>
            <TabContent activeTab={activeTab}>
              {!user.isPending && thinking_talents_on && 
                <TabPane tabId="thinkingTalents">
                  <ThinkingTalentsHome />
                </TabPane>
              }
              {mind_patterns_on &&
                <TabPane tabId="mindPattern">
                  <MindPatternsHome />
                </TabPane>
              }
              {user.id && !user.isPending && user.account.questionnaires_count > 0 &&
                <TabPane tabId="questionnaire">
                  <NewMemberDiscovery />
                </TabPane>
              }
            </TabContent>
          </div>
        }

        {(user.is_manager === 1 && teams_on) && <TeamsHome />}

        {
          user.accept_terms && !user.must_change_pwd && user.account && popups.map((popup, index) => {
            return <GenericPopup
              key={popup.id}
              id={popup.id}
              isOpen={currentPopupIndex === index}
              toggle={nextPopup}
              text={popup.text}
              show_command_button={popup.show_command_button}
              command_button_text={popup.command_button_text}
              command_button_link={popup.command_button_link}
              new_tab={popup.open_link_In_a_new_tab}
              exposition_frequency={popup.exposition_frequency}
            />
          })
        }

        {
          user.isPending &&
          <LoadingIndicator />
        }
        {
          pdf && pdf.isPending &&
          <LoadingIndicator />
        }

        <Card className="p-3">
            <Footer />
        </Card>
      </Container>
    </>
  )
}



